<template>
  <form id="hcpSearchForm" @submit.prevent="onSearch" v-if="show">
    <mu-paper class="searchBar">
      <mu-icon value="search" @click.native="onSearch" />
      <input type="text" :placeholder="$t('message.searchText')" v-model="searchTerm" />
    </mu-paper>
    <input type="submit" style="display: none;" />
  </form>
</template>

<script>
  import HcpApi from '../../api/Hcp';
  export default {
    name: 'hcp-search',
    watch: {
      "$route": function() {
        let self = this;
        self.searchTerm = self.$route.params.search;
        self.initMounted();
      }
    },
    data() {
      return {
        searchTerm: '',
      }
    },
    methods: {
      onSearch() {
        let self = this;
        let q = null;
        if(q = self.searchTerm) {
          let options = {
            name: 'HcpSearch',
            params: {
              search: q
            },
          };
          let route = self.$route.name;
          if( ( route === 'Downloads' ) || ( route === 'DownloadsCategory' ) ) {
            options.query = {
              type: "resources"
            };
          }
          self.$router.push(options)
        } else {
          self.$toastr.error('Please enter a search value');
        }
      },
      initMounted() {
        let self = this;
      }
    },
    mounted() {
      let self = this;
      self.searchTerm = self.$route.params.search;
      self.initMounted();
    },
    computed: {
      show() {
        let self = this;
        let route = self.$route.name;
        if ( ( route === 'Dashboard' ) || ( route === 'HcpCategories' ) || ( route === 'HcpCategory' ) || ( route === 'Downloads' ) || ( route === 'DownloadsCategory' ) || ( route === 'HcpSearch' ) ) {
          return true;
        }
      }
    }
  }

</script>

<style lang="less">
  #hcpSearchForm {
    margin: -24px;
    margin-bottom: 24px;
    @media only screen and (max-width: 480px) {
      margin: 0;
    }
    .mu-paper {
      box-shadow: none;
      border-bottom: 1px solid #D7D7D7;
    }
  }
</style>



// WEBPACK FOOTER //
// Search.vue?378d7529